<div *ngIf="perfil.rol_social && perfil.ID == misdatos.ID">
  <div id="seccion-salud" class="row mt-4 mb-3 align-items-center g-3 salud-head">
    <div class="col">
      <div class="salud-kicker"><i class="fa-solid fa-heart-pulse me-2"></i>BIENESTAR DE TUS MASCOTAS</div><h2 class="salud-heading">Salud y cuidados</h2><p class="salud-intro mb-0">Organiza las revisiones, tratamientos y recordatorios de tus mascotas. <span class="salud-private"><i class="fa-solid fa-lock me-1"></i> Solo tú puedes verlo</span></p>
    </div>
    <div class="col-12 col-lg-auto">
      <div class="pet-filters" role="group" aria-label="Filtrar mascotas">
        <button class="filter-button" (click)="seleccionarMascota(null)"
          [ngClass]="{'is-active': mascotaSeleccionada == null}"
          type="button" [attr.aria-pressed]="mascotaSeleccionada == null">Todas</button>
        <button class="filter-button" (click)="seleccionarMascota(mascota)"
          [ngClass]="{'is-active': mascotaSeleccionada?.ma_id == mascota.ma_id}"
          type="button" [attr.aria-pressed]="mascotaSeleccionada?.ma_id == mascota.ma_id" *ngFor="let mascota of mascotas; trackBy: trackByMascota">{{ mascota.ma_nombre | firstWord}}</button>
        <button type="button" class="filter-button add-button" (click)="nuevoCuidado()" data-bs-toggle="modal" data-bs-target="#anadirModal"><i class="fa-solid fa-plus me-2"></i>Añadir cuidado</button>
      </div>    
    </div>
  </div>
  <div class="mb-5 position-relative">
    <div class="salud-pet-card mb-3" *ngIf="mascotaSeleccionada != null">
      <div class="d-flex">
        <div>
          <img
            *ngIf="mascotaSeleccionada.foto?.foto_thumb"
            [src]="mascotaSeleccionada.foto?.foto_thumb"
            class="img-card rounded-4 pointer thumb-popup"
            width="60px"
            alt="Foto de perfil"
            [attr.data-full]="mascotaSeleccionada.foto?.foto_grande"
            [attr.data-titulo]="mascotaSeleccionada.ma_nombre"
            [attr.data-texto1]="mascotaSeleccionada.ma_tipo + ' ' + mascotaSeleccionada.ma_raza + ' de ' + mascotaSeleccionada.ma_edad"
            [attr.data-texto2]="(mascotaSeleccionada.ma_sexo === 'Macho' ? '<i class=\'fa-solid fa-mars\'></i>' : mascotaSeleccionada.ma_sexo === 'Hembra' ? '<i class=\'fa-solid fa-venus\'></i>' : '') + ' ' + mascotaSeleccionada.ma_sexo"
          />
        </div>
        <div class="ms-3">
          <h3>{{ mascotaSeleccionada.ma_nombre }}</h3>
          <div class="mb-1">
            <span *ngIf="mascotaSeleccionada.ma_raza && mascotaSeleccionada.ma_edad" title="Raza y edad">{{ mascotaSeleccionada.ma_raza }} · {{ mascotaSeleccionada.ma_edad }}</span>
            <span *ngIf="!mascotaSeleccionada.ma_raza && mascotaSeleccionada.ma_edad">{{ mascotaSeleccionada.ma_edad }}</span>
            <span *ngIf="mascotaSeleccionada.ma_tipo" title="Tipo"> · {{ mascotaSeleccionada.ma_tipo }}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="salud-main-card mb-3">
      <div class="row mb-3 align-items-center g-2">
        <div class="col">
          <p class="eyebrow"><i class="fa-regular fa-calendar-check me-2"></i>PLANIFICACIÓN</p>
          <h3 class="salud-section-title">Próximos cuidados y recordatorios</h3>
        </div>
        <div class="col-auto">
          <span class="status-pill">{{ pendientesCount }} pendientes</span>        
        </div>
      </div>
      <div *ngIf="busy > 0">
        <span class="spinner-border spinner-border-sm text-iguau" aria-hidden="true"></span>
        <span class="text-secondary ms-1">Cargando...</span>
      </div>
      <div *ngIf="!busy && cuidadosFiltrados.length == 0" class="salud-empty">
        <div class="salud-empty-inner">
          <div class="salud-empty-icon"><i class="fa-solid fa-calendar-plus"></i></div>
          <div class="salud-empty-text"><strong>Sin cuidados programados</strong><p>Añade vacunas, revisiones o recordatorios para tenerlo todo al día.</p></div>
          <button type="button" class="filter-button add-button" (click)="nuevoCuidado()" data-bs-toggle="modal" data-bs-target="#anadirModal"><i class="fa-solid fa-plus me-2"></i>Añadir cuidado</button>
        </div>
      </div>
      <article *ngFor="let cuidado of cuidadosFiltrados; trackBy: trackByCuidado" class="salud-care-item">
        <div class="salud-care-row" [class.is-done]="cuidado.mc_realizado == 'X'" [ngClass]="'tipo-' + getTipoVisual(cuidado)">
          <div class="salud-care-head">
            <button class="salud-toggle" type="button" (click)="marcarRealizado(cuidado)"
              [disabled]="esCuidadoFuturo(cuidado)"
              [attr.title]="esCuidadoFuturo(cuidado) ? 'Podrás marcarlo como realizado a partir de la fecha programada' : (cuidado.mc_realizado == 'X' ? 'Marcar pendiente' : 'Marcar realizado')"
              [attr.aria-label]="esCuidadoFuturo(cuidado) ? 'Cuidado programado para una fecha futura' : (cuidado.mc_realizado == 'X' ? 'Marcar pendiente' : 'Marcar realizado')"
              [attr.aria-pressed]="cuidado.mc_realizado == 'X'">
              <i class="fa-circle" [ngClass]="{'fa-regular': cuidado.mc_realizado != 'X', 'fa-solid': cuidado.mc_realizado == 'X'}"></i>
            </button>

            <img [src]="getMascota(cuidado.mc_ma_id)?.foto?.foto_thumb || getMascota(cuidado.mc_ma_id)?.foto_principal_thumb || avatarFallback"
              class="salud-care-avatar" [alt]="'Foto de ' + cuidado.ma_nombre" />

            <div class="salud-care-main">
              <div class="salud-care-title-row">
                <div class="salud-care-title-group">
                  <h4 class="salud-care-name">{{ cuidado.ma_nombre }}</h4>
                  <span class="salud-care-kind-chip">
                    <i class="fa-solid" [ngClass]="getTipoIcono(cuidado)" aria-hidden="true"></i>
                    {{ cuidado.va_nombre || 'Cuidado' }}
                  </span>
                </div>
                <span *ngIf="cuidado.mc_realizado == 'X'" class="salud-care-done-label"><i class="fa-solid fa-check me-1"></i>Realizado</span>
              </div>

              <div class="salud-care-schedule">
                <span class="salud-care-alert hoy" *ngIf="avisoHoy(cuidado)"><i class="fa-solid fa-bell me-1"></i>¡Hoy toca!</span>
                <span class="salud-care-alert atrasado" *ngIf="avisoAtrasado(cuidado)"><i class="fa-solid fa-triangle-exclamation me-1"></i>Atrasado</span>
                <span class="salud-care-recurring" *ngIf="cuidado.mc_periodicidad && cuidado.mc_periodicidad !== 'ninguna'"><i class="fa-solid fa-rotate me-1"></i>{{ periodicidadNombre(cuidado) }}</span>
                <span class="salud-care-date"><i class="fa-regular fa-calendar" aria-hidden="true"></i>{{ cuidado.mc_fecha | cuandoFechas }}</span>
                <span class="salud-care-time" *ngIf="cuidado.mc_hora"><i class="fa-regular fa-clock" aria-hidden="true"></i>{{ cuidado.mc_hora | slice:0:5 }}</span>
              </div>

              <div class="salud-care-notes" *ngIf="cuidado.mc_notas">
                <app-leer-mas [texto]="cuidado.mc_notas" [limite]="140"></app-leer-mas>
              </div>

              <div class="salud-care-actions">
                <button type="button" class="salud-action" (click)="editarCuidado(cuidado)" data-bs-toggle="modal" data-bs-target="#anadirModal" aria-label="Editar cuidado">
                  <i class="fa-regular fa-pen-to-square" aria-hidden="true"></i>
                  <span>Editar</span>
                </button>
                <button type="button" class="salud-action salud-action-danger" (click)="eliminarCuidado(cuidado)" aria-label="Eliminar cuidado">
                  <i class="fa-regular fa-trash-can" aria-hidden="true"></i>
                  <span>Borrar</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </article>
    </div>
  </div>

  <!-- Modal -->
  <div class="modal fade" id="anadirModal" tabindex="-1" aria-labelledby="anadirModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable">
      <div class="modal-content salud-modal">
        <div class="modal-header">
          <h2 class="modal-title fs-5" id="anadirModalLabel">{{ nuevocuidado.mc_id ? 'Editar cuidado' : 'Añadir cuidado' }}</h2>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Cerrar"></button>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col-12 col-sm-12 col-md-6">
              <label for="mascota" class="form-label">Mascota</label>
              <select id="mascota" class="form-select" [(ngModel)]="nuevocuidado.mc_ma_id">
                <option value="0" disabled>Selecciona una mascota</option>
                <option *ngFor="let mascota of mascotas" [value]="mascota.ma_id">{{ mascota.ma_nombre }}</option>
              </select>
            </div>
            <div class="col-12 col-sm-12 col-md-6">
              <label for="tipoCuidado" class="form-label">Tipo de cuidado</label>
              <select id="tipoCuidado" class="form-select" [(ngModel)]="nuevocuidado.mc_tipo">
                <option value="" disabled>Selecciona el tipo de cuidado</option>
                <option *ngFor="let cuidado of tipoCuidados" [value]="cuidado.va_id">{{ cuidado.va_nombre }}</option>
              </select>
            </div>
          </div>
          <div class="row">
            <div class="col-12 col-sm-12 col-md-6">
              <label for="fechaCuidado" class="form-label">Fecha</label>
              <input type="date" id="fechaCuidado" class="form-control" [(ngModel)]="nuevocuidado.mc_fecha">
            </div>
            <div class="col-12 col-sm-12 col-md-6">
              <label for="horaCuidado" class="form-label">Hora</label>
              <input type="time" id="horaCuidado" class="form-control" [(ngModel)]="nuevocuidado.mc_hora">
            </div>
          </div>
          <div class="row mt-3 g-3">
            <div class="col-12 col-sm-7">
              <label for="periodicidad" class="form-label">Periodicidad</label>
              <select id="periodicidad" class="form-select" [(ngModel)]="nuevocuidado.mc_periodicidad">
                <option *ngFor="let opcion of periodicidades" [value]="opcion.valor">{{ opcion.texto }}</option>
              </select>
            </div>
            <div class="col-12 col-sm-5" *ngIf="nuevocuidado.mc_periodicidad === 'personalizada'">
              <label for="intervaloDias" class="form-label">Repetir cada (días)</label>
              <input id="intervaloDias" type="number" min="1" max="3650" step="1" class="form-control" [(ngModel)]="nuevocuidado.mc_intervalo" />
            </div>
            <div class="col-12"><div class="salud-repeat-help"><i class="fa-regular fa-bell me-2"></i>El día programado verás el aviso «¡Hoy toca!». Al marcar un cuidado periódico como realizado, se preparará la siguiente fecha.</div></div>
          </div>
          <div class="row mt-3">
            <div class="col">
              <label for="notasCuidado" class="form-label">Notas</label>
              <textarea id="notasCuidado" class="form-control" rows="4" placeholder="Añade cualquier detalle adicional sobre el cuidado..." [(ngModel)]="nuevocuidado.mc_notas"></textarea>
            </div>
          </div>        
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-outline-secondary" data-bs-dismiss="modal">Cancelar</button>
          <button type="button" class="btn btn-salud" (click)="guardarCuidado()" [disabled]="validaFormulario() || guardando">{{ guardando ? 'Guardando...' : 'Guardar cuidado' }}</button>
        </div>
      </div>
    </div>
  </div>
</div>